import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { unifiedColors } from 'styles/colors'
import { media } from 'styles/responsive'

export const FixedMenuContainer = styled.div`
  font-weight: 500;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 52px;
  background-color: ${unifiedColors.surface.subdued};
  box-shadow: 0.5px 1px 0px 0px rgba(0, 0, 0, 0.05);
  position: relative;
`

export const NavContainer = styled.nav`
  display: flex;
`
export const AContainer = styled.a<{ $isActive: boolean }>`
  display: flex;
  margin-right: 20px;
  text-decoration: none;
  padding: 12px 16px;
  border-radius: 52px;
  color: ${unifiedColors.label.subdued};
  font-weight: 600;

  ${({ $isActive }) =>
    $isActive &&
    css`
      font-weight: bold;
      background: ${unifiedColors.button.secondary.default};
      color: ${unifiedColors.label.onGreen};
    `}

  ${media.maxWidth.sm} {
    margin-right: 0;
  }
`
